import { getMediaUrl } from "utils/media-upload"

/**
 * Extracts the main photo URL from an experience object
 * Priority: cropped_photos (position 0) > photos (position 0) > first photo
 * @param {Object} experience - The experience object
 * @returns {string|null} - The main photo URL or null
 */
export const getExperienceMainPhoto = (experience) => {
  if (!experience) return null

  const hasCropped = Array.isArray(experience.cropped_photos) && experience.cropped_photos.length > 0
  const croppedPhoto = hasCropped ? experience.cropped_photos.find((p) => p?.position === 0) : null

  const positionedPhoto = Array.isArray(experience.photos) ? experience.photos.find((p) => p?.position === 0) : null

  const fallbackPhoto = Array.isArray(experience.photos) && experience.photos.length > 0 ? experience.photos[0] : null

  return getMediaUrl(croppedPhoto) || getMediaUrl(positionedPhoto) || getMediaUrl(fallbackPhoto) || null
}
